import getAPIPath from '../modules/api-location';
function getActivityFeedService(successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/activity-feed`,
    type: `get`,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
}
module.exports = getActivityFeedService;


// WEBPACK FOOTER //
// ./library/js/services/activityfeed.service.js